import { render, staticRenderFns } from "./deactivate-popup.vue?vue&type=template&id=19f3d84c&scoped=true&"
import script from "./deactivate-popup.vue?vue&type=script&lang=js&"
export * from "./deactivate-popup.vue?vue&type=script&lang=js&"
import style0 from "./deactivate-popup.vue?vue&type=style&index=0&id=19f3d84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f3d84c",
  null
  
)

component.options.__file = "deactivate-popup.vue"
export default component.exports